import {useProjectId} from "../../shopdrawing/ProjectName";
import {QuoteSwitcher} from "../pricing/QuoteSwitcher";
import React from "react";

export function MiscSwitcher() {
    const projectId = useProjectId();

    return (
        <QuoteSwitcher
            title="Misc"
            url={`/project/${projectId}/shop-drawing/misc`}
            quoteTitle="Quote Misc"
            quoteURL={`/project/${projectId}/quote/-1/misc`} />
    )
}

